module.exports = __webpack_public_path__ + "img/kjcg-yzxm.078671ef.jpg";